'use client'

import { UniqueIdentifier } from '@dnd-kit/core'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { SortableItemContextProvider } from '@repo/ui/components'
import { cn } from '@repo/ui/lib'
import { CSSProperties, PropsWithChildren } from 'react'

interface Props {
  className?: string
  id: UniqueIdentifier
}

export const SortableItem = ({ children, className, id }: PropsWithChildren<Props>) => {
  const {
    attributes,
    isDragging,
    listeners,
    setActivatorNodeRef,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id })

  const style: CSSProperties = {
    transform: CSS.Translate.toString(transform),
    transition,
  }

  return (
    <SortableItemContextProvider {...{ attributes, listeners, ref: setActivatorNodeRef }}>
      <div
        className={cn('w-full', isDragging && 'opacity-40', className)}
        ref={setNodeRef}
        style={style}
      >
        {children}
      </div>
    </SortableItemContextProvider>
  )
}
